import { useState, useEffect, useMemo } from 'react';
import { Outlet, useNavigate, useLocation, Link } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import Localization from '../utils/localization';
import Copilot from '../components/Copilot';
import './BaseLayout.scss';
import {
    DesktopOutlined,
    LogoutOutlined,
    DollarOutlined,
    PieChartOutlined,
    FileOutlined,
    SettingOutlined,
    UnorderedListOutlined,
    UploadOutlined,
    DownloadOutlined,
    VerticalAlignTopOutlined,
} from '@ant-design/icons';

const { Sider, Content } = Layout;

export const menuItems = [
    {
        key: '/',
        label: Localization.sidemenu.accountStructure,
        icon: <PieChartOutlined />,
    },
    {
        key: '/entities',
        label: Localization.sidemenu.entities,
        icon: <DesktopOutlined />,
    },
    {
        key: '/business-cases',
        label: Localization.sidemenu.businessCase,
        icon: <FileOutlined />,
    },
    {
        key: '/reporting',
        label: Localization.sidemenu.reporting,
        icon: <UnorderedListOutlined />,
    },
    {
        key: '/import',
        label: Localization.sidemenu.import,
        icon: <UploadOutlined />,
    },
    {
        key: 'export-menu',
        label: Localization.sidemenu.export,
        icon: <UploadOutlined />,
        children: [
            {
                key: '/export/config',
                label: Localization.sidemenu.exportConfig,
            },
            { key: '/export', label: Localization.sidemenu.export },
        ],
    },
];

const BaseLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(null);

    useEffect(() => {}, []);

    const onCollapse = (collapsed) => {
        setCollapsed(collapsed);
    };

    const onSelect = ({ key }) => {
        navigate(key);
    };

    const inImportPage = useMemo(() => location.pathname.startsWith('/import'), [location.pathname]);
    const defaultOpenKeys = inImportPage ? ['import-menu'] : undefined;
    
   return (
    <Layout style={{ height: '100vh' }}>
        <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
            <div className="logo" />
            <div className="sider-menu-wrapper">
                <Menu
                    theme="dark"
                    defaultSelectedKeys={[location.pathname]}
                    defaultOpenKeys={defaultOpenKeys}
                    mode="inline"
                    selectedKeys={[location.pathname]}
                    onSelect={onSelect}
                >
                    <Menu.Item key="/" icon={<DesktopOutlined />}>
                        {Localization.sidemenu.organization}
                    </Menu.Item>
                    <Menu.Item key="/business-cases" icon={<FileOutlined />}>
                        {Localization.sidemenu.businessCase}
                    </Menu.Item>
                    <Menu.Item key="/reporting" icon={<UnorderedListOutlined />}>
                        {Localization.sidemenu.reporting}
                    </Menu.Item>
                </Menu>

                <div style={{ flex: '1 1 0', minHeight: 0 }} />

                <Menu
                    theme="dark"
                    mode="inline"
                    onSelect={onSelect}
                    selectedKeys={[location.pathname]}
                >
                    <Menu.Item key="/import" icon={<DownloadOutlined />}>
                        {Localization.sidemenu.import}
                    </Menu.Item>
                    <Menu.SubMenu key="export-menu" title={Localization.sidemenu.export} icon={<UploadOutlined />}>
                        <Menu.Item key="/export/config">{Localization.sidemenu.exportConfig}</Menu.Item>
                        <Menu.Item key="/export">{Localization.sidemenu.export}</Menu.Item>
                    </Menu.SubMenu>
                    <Menu.Item key="/accountstructure" icon={<PieChartOutlined />}>
                        {Localization.sidemenu.accountStructure}
                    </Menu.Item>
                    <Menu.Item key="/allocations" icon={<VerticalAlignTopOutlined />}>
                        {Localization.sidemenu.allocations}
                    </Menu.Item>
                    <Menu.Item key="/settings" icon={<SettingOutlined />}>
                        {Localization.sidemenu.settings}
                    </Menu.Item>
                    <Menu.Item
                        key="logout-action"
                        icon={<LogoutOutlined />}
                        onClick={() => { window.location.href = '/api/logout'; }}
                        selectable={false}
                    >
                        {Localization.sidemenu.logout}
                    </Menu.Item>
                </Menu>
            </div>
        </Sider>
            {inImportPage ? (
                <Layout className="site-layout import-pages">
                    <Outlet />
                </Layout>
            ) : (
                <Layout className="site-layout">
                    <Content style={{ margin: '0 16px' }}>
                        <Outlet />
                    </Content>
                </Layout>
            )}
            <Copilot />
        </Layout>
    );
};
export default BaseLayout;
